import { AST, OverridenASTs } from '../types';

export function checkASTs(preferences: OverridenASTs, asts: AST[]) {
	if (!!!asts) {
		return true;
	}
	return asts.reduce((acc, ast) => {
		return acc && !!preferences[ast];
	}, true);
}
